import { BaseCategory } from "~/types/baseCategory";
import { getSiteOrigin } from "~/utils/getSiteOrigin";

const OG_IMAGE_PATH_PREFIX = "/og";
export const CATEGORY_OG_IMAGE_SLUGS = Object.values(BaseCategory);

export const DEFAULT_CATEGORY_OG_IMAGE_SLUG = BaseCategory.Other;

const isCategoryOgImageSlug = (slug: string): slug is BaseCategory =>
  CATEGORY_OG_IMAGE_SLUGS.includes(slug as BaseCategory);

export const normalizeCategoryOgImageSlug = (
  categorySlug?: string | null
): BaseCategory => {
  if (!categorySlug) {
    return DEFAULT_CATEGORY_OG_IMAGE_SLUG;
  }

  const normalized = categorySlug.trim().toLowerCase();

  if (isCategoryOgImageSlug(normalized)) {
    return normalized;
  }

  return DEFAULT_CATEGORY_OG_IMAGE_SLUG;
};

export const getCategoryOgImageUrl = (
  categorySlug?: string | null,
  siteOrigin?: string | null
): string => {
  const slug = normalizeCategoryOgImageSlug(categorySlug);
  return `${getSiteOrigin(siteOrigin)}${OG_IMAGE_PATH_PREFIX}/${slug}.png`;
};
